import { Facebook, GitHub, Twitter, LinkedIn } from '@mui/icons-material';
import { Box, IconButton, Typography } from '@mui/material';
import React from 'react';
import '../About/About.css'

const Footer = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-end',
        mt: 18,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mb: 2,
        }}
      >
        <IconButton
          href='https://www.linkedin.com/in/sriram-radhey-nirujogi-469672248/'
          target='_blank'
          sx={{
            backgroundColor: 'white',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '75%',
            transition: 'background-color 0.3s, transform 0.3s',
            '&:hover': {
              backgroundColor: 'lightblue', 
              transform: 'scale(1.1)',
            },
            margin: 1,
          }}
        >
          <LinkedIn />
        </IconButton>
        <IconButton
          href='https://github.com/Sriram-Radhey'
          target='_blank'
          sx={{
            backgroundColor: 'white',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '75%',
            transition: 'background-color 0.3s, transform 0.3s',
            '&:hover': {
              backgroundColor: 'lightgray', 
              transform: 'scale(1.1)', 
            },
            margin: 1,
          }}
        >
          <GitHub />
        </IconButton>
        <IconButton
        href='https://x.com/n_radhey'
        target='_blank'
          sx={{
            backgroundColor: 'white',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '75%',
            transition: 'background-color 0.3s, transform 0.3s',
            '&:hover': {
              backgroundColor: 'darkgray',
              transform: 'scale(1.1)',
            },
            margin: 1,
          }}
        >
          <Twitter/>
        </IconButton>
        <IconButton
         href='https://www.facebook.com/profile.php?id=100074356981626'
         target='_blank'
          sx={{
            backgroundColor: 'white',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '75%',
            transition: 'background-color 0.3s, transform 0.3s',
            '&:hover': {
              backgroundColor: 'lightblue',
              transform: 'scale(1.1)',
            },
            margin: 1,
          }}
        >
          <Facebook />
        </IconButton>
      </Box>
      <Typography sx={{ color: 'white', margin: 0,fontSize:20,
      '@media (min-width:150px) and (max-width:600px)':{
        fontSize:10
      }
      }} className="no-select">Designed and Developed by N.Sriram Radhey. @ All Rights Reserved</Typography>
    </Box>
  );
};

export default Footer;